import React, { Component } from 'react'
import {Row, Col,Card,CardBody} from 'reactstrap'
import {Link} from 'react-router-dom'
import Table from '../common/Table'

export default class index extends Component {
  render() {
    return (
      <div className="main-content">
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Sinh viên đang hoạt động</h5>
                  <div>
                    <Link to="/admin/all" className="btn btn-sm btn-default">Xem thêm</Link>
                  </div>
                </div>
                <div className="m-t-30">
                  <Table columns={[
                    {
                      Header:"a",
                      columns: [
                        {
                          Header: 'First Name',
                          accessor: 'firstName',
                        },
                        {
                          Header: 'Last Name',
                          accessor: 'lastName',
                        },
                      ],
                    }
                  ]} data={[]}/>
                </div>
              </CardBody>
            </Card>
            
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js